export function getRandomId() {
  const randomString = Math.random().toString(36).slice(2, 8);
  return `rid-${randomString}`;
}
